export function init () {

    if(document.getElementById('cookieBanner'))
    {
        if(document.cookie.indexOf('readcookieagreement=') === -1) {
            document.getElementById('cookieBanner').style.display = 'block';
        }
    
        var closeButton = document.getElementsByClassName('js-cookie-banner-close')[0];
        closeButton.addEventListener('click', function() {
            document.getElementById('cookieBanner').style.display = 'none';
            var today = new Date();
            var expire = new Date();
            expire.setTime(today.getTime() + 3600000 * 24 * 365);
            document.cookie = 'readcookieagreement=true; expires=' + expire.toGMTString() + ';';
        });
    }
}